import type { MultiSelectProps } from '@fv/client-components/combobox'

import {
  type ShipperClassNames,
  ShipperComboBox,
  type ShipperInternalKeys,
} from './ShipperComboBox'

type Props<T> = Omit<MultiSelectProps<T>, ShipperInternalKeys> & {
  classNames?: ShipperClassNames<T>
  showTrigger?: boolean
}

export function ShipperMultiSelect<T>({
  classNames,
  name,
  value,
  showTrigger,
  ...rest
}: Props<T>) {
  return (
    <div className={classNames?.container}>
      <ShipperComboBox
        multiple
        name={name}
        value={value}
        onChange={rest.onChange}
        showTrigger={showTrigger}
        classNames={{
          root: `flex flex-wrap items-center gap-1 min-w-0 bg-white border border-[#b3b3b3] border-b-[0.115rem] border-b-fv-blue min-h-[2.8rem] px-2 py-1 focus-within:border-b-[#ff6501] hover:border-b-[#ff6501]${showTrigger ? ' relative pr-8' : ''}`,
          chip: 'inline-flex max-w-full min-w-0 bg-fv-beer-light border border-fv-gray text-sm items-stretch',
          chipLabel: 'p-1 truncate',
          chipRemove:
            'cursor-pointer bg-white flex items-center border-l border-fv-gray p-1 [&_svg]:text-fv-orange-bright hover:[&_svg]:text-fv-gray-dark ',
          input:
            'flex-1 min-w-[4rem] outline-hidden bg-transparent text-[#333] leading-[1.4rem]',
          ...classNames,
        }}
        {...rest}
      />
    </div>
  )
}
